import EntityService, { WithSubcollection } from '@/services/EntityService'
import { Proposal, proposalConverter } from '@/models/proposal'

@WithSubcollection<Proposal>('changeOrders', proposalConverter)
export default class ProposalService extends EntityService<Proposal> {
  constructor() {
    super({ collectionName: 'proposals', converter: proposalConverter })
  }

  async deleteProposal (proposalId: string): Promise<boolean> {
    const allPromises = []
    const changeOrders = await this.getChangeOrders(proposalId)
    changeOrders.forEach((changeOrder: Proposal) => {
      allPromises.push(this.deleteChangeOrder(proposalId, changeOrder.id))
    })

    allPromises.push(this.forceDelete(proposalId))
    await Promise.all(allPromises)
    return true
  }
}
